import { InjectionToken } from '@angular/core';

export const dataToken = new InjectionToken<any>('sub-resource-data-token');

export abstract class BaseSubResource {}
